'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.controller('LoginCtrl', function($injector, $cookies, userService, adobeAnalyticsService,
  ErrorResponseHandler, loginService, urlService,otppConstants) {

  var $rootScope = $injector.get('$rootScope');
  var $sce = $injector.get('$sce');
  var $state = $injector.get('$state');
  var $stateParams = $injector.get('$stateParams');
  var $translate = $injector.get('$translate');
  var $q = $injector.get('$q');
  this.capsaConsent = false;

  var self = this;

  $(document.documentElement).on('capsaAcceptEvent', () => { //connects to member-terms-of-use component
    self.capsaConsent = true;
    this.goToAuth();
  });

  this.goToAuth = function() {
    agreeToCapsa().then(function() {
      window.location.href = '/auth/';
    });
  };

  function agreeToCapsa() {
    var $capsaPromise = fetch('/auth/capsa/' + $cookies.get('capsaCookie') + ' /agree', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    });
    $cookies.remove('capsaCookie');

    return $capsaPromise;
  }


  function successfulLogin(account) {
    userService.onLogin(account)
    .then(function(result) {
      adobeAnalyticsService.trackLoginEvent();
      self.pleaseWaitMessage = false;
      sessionStorage.removeItem('loginLoading');
      if($cookies.get(otppConstants.authCallbackDestinationKey)!=undefined)
        urlService.pageRedirect($cookies.get(otppConstants.authCallbackDestinationKey));
    })
    .catch(function(reason) {
      // case where userService.onLogin errors out
      if(reason!="LoginInterrupted")
        $state.go('home', {err: '502'});
    });
  }

  function failedLogin(response) {
    if (response.status.toString().charAt(0) === '5') {
      adobeAnalyticsService.trackTechnicalDifficulties();
    } else {
      adobeAnalyticsService.trackFailedLoginEvent();
    }

    self.pleaseWaitMessage = false;
    sessionStorage.removeItem('loginLoading');

    //Dispatch event for Stencil JS components
    return $q.reject(response);
  }

  this.login = function() {
    //remove existing error message when user tries to sign in
    this.unsetErrorMessage();
    self.pleaseWaitMessage = true;
    sessionStorage.setItem('loginLoading','true');
    loginService.login().catch(function(response) {
      return failedLogin(response);
    }).then(function() {
      return userService.getAccountInformation();
    }).then(function(session) {
      userService.setCurrentUserAccount({
        irn: session.account,
        accountHash: session.accountHash
      });
      // This event is used in the HeaderCtrl
      $rootScope.$broadcast('otppLogin.loginSuccess');
      successfulLogin(session.account);
    });
  };

  this.validateModel = function() {
    //check client validation
    if (this.myForm.account.$error.pattern) {
      setErrorMessage('login.error.client');
    }
  };

  //controller functions

  // Needed for redirect passing on interstitial login page
  this.r = $stateParams.r;

  if ($stateParams.err && $stateParams.err === '5xx') {
    setErrorMessage('error.server.not.available');
  }

  $translate('login.register.href').then(function(url) {
    self.registerUrl = $sce.trustAsResourceUrl(url);
  });

  //DMWS-1072, To prevent event handler accumulates,delete existing 'validLogin' handler then add new
  $(document.documentElement).off('validLogin');
  $(document.documentElement).on('validLogin', event => {
    this.login(event.detail);
  });

});
